export const RocketManApplicationPort = 8786;

export const notifyApplicationLicense = (port: number, key: string) => {
    try {
        fetch(`http://localhost:${port}/keyLink?key=${key}`);
    } catch (error) {}
};
